import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988abdcb7c6670013a7b9fd/lenormand_tarot_reading/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988abdcb7c6670013a7b9fd/lenormand_tarot_reading/src/components/common/GTMPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988abdcb7c6670013a7b9fd/lenormand_tarot_reading/src/components/ui/CookieConsentModal.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988abdcb7c6670013a7b9fd/lenormand_tarot_reading/src/styles/index.css");
